function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, bank) {
  console.log(bank === null || bank === void 0 ? void 0 : bank.selected_resource);
  var prompt = bank !== null && bank !== void 0 && bank.selected_resource ? "R" : "Select r";
  var html = '';
  if (Object.keys(bank.my_resources).length > 0) {
    html += "<div class=\"saitoa bank-overlay\">\n\t\t\t          <div class=\"settlers-items-container\">\n\t\t\t            <div class=\"settlers-item-info-text\">".concat(prompt, "esource to give bank:</div>");
    for (var i in bank.my_resources) {
      var row = "<div class=\"settlers-cards-container settlers-trade-resources \n\t\t\t".concat((bank === null || bank === void 0 ? void 0 : bank.selected_resource) == i ? 'selected' : '', " \n\t\t\t").concat(mod.canPlayerTradeWithBank() ? "" : "settlers-row-disabled", "\" id=\"").concat(i, "\" data-selected=\"0\" >");
      for (var j = 0; j < bank.minForTrade[i]; j++) {
        row += "<img src=\"".concat(mod.returnCardImage(i), "\">");
      }
      row += "</div>";
      if (!(bank !== null && bank !== void 0 && bank.selected_resource) || bank.selected_resource == i) {
        html += row;
      }
    }
  } else {
    html += "<div class=\"saitoa bank-overlay\">\n\t\t\t          <div class=\"settlers-items-container\">\n\t\t\t            <div class=\"settlers-item-info-text\">Bank/Port Trading</div>";
    var three4one = false;
    for (var _i in bank.minForTrade) {
      if (bank.minForTrade[_i] == 3) {
        three4one = true;
      } else if (bank.minForTrade[_i] == 2) {
        var _row = "<div class=\"settlers-cards-container settlers-row-disabled\">";
        for (var _j = 0; _j < bank.minForTrade[_i]; _j++) {
          _row += "<img src=\"".concat(mod.returnCardImage(_i), "\">");
        }
        _row += "</div>";
        html += _row;
      }
    }
    html += "<div class=\"settlers-cards-container settlers-item-info-text\">".concat(three4one ? 3 : 4, " of the same resource</div>");
  }
  html += "</div>";
  if (!(bank !== null && bank !== void 0 && bank.selected_resource)) {
    return html + "</div>";
  }
  html += "<div class=\"settlers-items-container settlers-items-container-desired-resources\">\n            <div class=\"settlers-item-info-text\">Select resource to buy:</div>\n            <div class=\"settlers-cards-container settlers-desired-resources\">";
  var _iterator = _createForOfIteratorHelper(mod.returnResources()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _i2 = _step.value;
      if (_i2 !== bank.selected_resource) {
        html += "<img id=\"".concat(_i2, "\" src=\"").concat(mod.returnCardImage(_i2), "\">");
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += "</div>\n          </div>\n        </div>";
  return html;
};